import { render, staticRenderFns } from "./RecordNameSetup.vue?vue&type=template&id=09188af4&scoped=true&"
import script from "./RecordNameSetup.vue?vue&type=script&lang=ts&"
export * from "./RecordNameSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09188af4",
  null
  
)

export default component.exports